import { Outlet } from '@tanstack/react-router';
import A2UIGalleryShell from '@/a2ui/gallery/A2UIGalleryShell';
import A2UIMonacoRuntimeProvider from '@/a2ui/preview/A2UIMonacoRuntimeProvider';
import { Route as WorkbenchRoute } from '@/routes/_workbench';

export default function A2UIWorkbenchLayout() {
  const { sidebarExamples, initialSidebarExpanded } = WorkbenchRoute.useLoaderData();
  return (
    <A2UIMonacoRuntimeProvider>
      <A2UIGalleryShell examples={sidebarExamples} initialSidebarExpanded={initialSidebarExpanded}>
        <Outlet />
      </A2UIGalleryShell>
    </A2UIMonacoRuntimeProvider>
  );
}
